module.exports = __webpack_public_path__ + "img/banana-smoothie.69f2dc8b.jpg";